"use client";

import {
  ConnectionSearchInteractionOption,
  FilterBar,
  useEmitConnectionSearchInteractionEvent,
  useLegacyParameterMigration,
} from "@zapier/shared";
import { useConnectionsFilterConfig } from "./useConnectionsFilterConfig";

interface Props {
  isDisabled?: boolean;
  showFiltersButton?: boolean;
}

export function ConnectionsFilterBar({ isDisabled, showFiltersButton }: Props) {
  const {
    filters,
    quickFilters,
    quickFilterContext,
    onFilterInteraction,
    legacyMigrate,
  } = useConnectionsFilterConfig();
  const { emit } = useEmitConnectionSearchInteractionEvent();

  // Rewrites legacy `owner=`/`app=` URLs to `owners=`/`apps=` on mount.
  useLegacyParameterMigration({ migrate: legacyMigrate });

  return (
    <FilterBar
      namespace="connections-filter-bar"
      filters={filters}
      quickFilters={quickFilters}
      quickFilterContext={quickFilterContext}
      isDisabled={isDisabled}
      showFiltersButton={showFiltersButton}
      onFilterInteraction={onFilterInteraction}
      onSearch={(value) => {
        if (value.trim().length > 0) {
          emit(ConnectionSearchInteractionOption.Keyword);
        }
      }}
    />
  );
}
